import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { ModuleManifest } from '@cavicode/network-ui';
import { modulesApi } from '@/api/modules';

/**
 * Store для загруженных модульных манифестов.
 * SPA загружает манифесты через GET /api/modules (BFF) при старте.
 * Router и SideNav используют эти данные для динамической регистрации routes и nav.
 */
export const useModulesStore = defineStore('modules', () => {
    const manifests = ref<ModuleManifest[]>([]);
    const loaded = ref(false);
    const loading = ref(false);
    const error = ref<string | null>(null);
    let loadPromise: Promise<void> | null = null;

    async function load(force = false): Promise<void> {
        if (loaded.value && !force) return;
        if (loadPromise) return loadPromise;

        loadPromise = (async () => {
            loading.value = true;
            try {
                manifests.value = await modulesApi.list();
                loaded.value = true;
                error.value = null;
            } catch (e) {
                error.value = e instanceof Error ? e.message : 'Не удалось загрузить модули';
            } finally {
                loading.value = false;
                loadPromise = null;
            }
        })();

        return loadPromise;
    }

    function clear() {
        manifests.value = [];
        loaded.value = false;
        loading.value = false;
        error.value = null;
    }

    return {
        manifests,
        loaded,
        loading,
        error,
        load,
        clear
    };
});
